import type { CellProps } from '../../../interfaces'
import type { FC } from 'react'

type Props = CellProps
const MoneyCell: FC<Props> = ({ title }) => {
  let formatted = title
  const value = Number.parseFloat(title)

  if (!isNaN(value)) {
    formatted = value.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    })
  }

  return <div className='custom-cell custom-cell__money'>{formatted || '—'}</div>
}

export default MoneyCell
